import { css } from "styled-components";
import token from "styled-token";
import { MediaObject } from "drywall";
import { spaceMixin } from "../spaceMixin";
import { typographyMixin } from "../typographyMixin";
import { statusDialogMixin } from "../statusDialogMixin";
import { StyledTextButton } from "../../components/TextButton/TextButton";
import { StyledCloseButton } from "../../components/CloseButton/CloseButton";
import { StyledHeading } from "../../components/Text/Heading";
import { StyledIcon } from "../../components/Icon/Icon";
import { StyledImage } from "../../components/Image/Image";
var columnCSS = token("Upsell.columnMediaSize", function (maxHeight) {
  return css(["", "{", ",", "{max-width:100%;max-height:", "px;}}"], MediaObject.Media, StyledImage, StyledIcon, maxHeight);
});
var rowCSS = token("Upsell.rowMediaSize", function (size) {
  return css(["", "{height:", "px;width:", "px;flex-shrink:0;", ",", "{height:100%;width:100%;}}"], MediaObject.Media, size, size, StyledImage, StyledIcon);
});

var textButtonCSS = function textButtonCSS(props) {
  return css(["", "{margin:", " 0 0;padding:0;display:block;}"], StyledTextButton, spaceMixin("xs")(props));
};

var directionCSS = function directionCSS(props) {
  var direction = props.direction;
  var styles = [];

  if (direction === "column") {
    styles.push(columnCSS(props));
  } else {
    styles.push(rowCSS(props));
  }

  return styles;
};

var colorCSS = function colorCSS(props) {
  var background = props.background;
  return token({
    backgroundColor: "colors." + background,
    borderColor: "colors." + background
  }, {
    defaultValue: ""
  }, function (tokens) {
    var styles = ["background-color: " + tokens.backgroundColor + "};"];

    if (background === "backgroundDarkBlue") {
      styles.push(statusDialogMixin(Object.assign({
        inverse: true
      }, props)));
    }

    if (background !== "backgroundWhite") {
      styles.push("border-color: " + tokens.borderColor + "};");
    }

    return styles;
  })(props);
};
/** @class UpsellMixin */

/** @method */


export var UpsellMixin = function UpsellMixin(props) {
  return token("Upsell.headingFontType", function (fontType) {
    return css(["", "{", "}position:relative;", "{position:absolute;top:", ";right:", ";}", " ", " ", ""], StyledHeading, typographyMixin(Object.assign({
      fontType: fontType
    }, props)), StyledCloseButton, spaceMixin("sm")(props), spaceMixin("sm")(props), colorCSS(props), directionCSS(props), textButtonCSS(props));
  })(props);
};